import TauxConsultations from '@/views/parametres/assurances/liste-assures/assure-detail/taux-consultations'
import TauxAnalyses from '@/views/parametres/assurances/liste-assures/assure-detail/taux-analyses'
import TauxExamens from '@/views/parametres/assurances/liste-assures/assure-detail/taux-examens'
import TauxMedicaments from '@/views/parametres/assurances/liste-assures/assure-detail/taux-medicaments'
import TauxConsommables from '@/views/parametres/assurances/liste-assures/assure-detail/taux-consommables'
import TauxChirurgies from '@/views/parametres/assurances/liste-assures/assure-detail/taux-chirurgies'
import TauxBilanSante from '@/views/parametres/assurances/liste-assures/assure-detail/taux-bilan-sante'
import TauxAdmissions from '@/views/parametres/assurances/liste-assures/assure-detail/taux-admissions'
import TauxActes from '@/views/parametres/assurances/liste-assures/assure-detail/taux-actes'
import TauxObservations from '@/views/parametres/assurances/liste-assures/assure-detail/taux-observations'
import TauxChambres from '@/views/parametres/assurances/liste-assures/assure-detail/taux-chambres'

// import $ from 'jquery'

export default {
    name: 'taux-prestations', 
    components: {
        TauxConsultations, TauxAnalyses, TauxExamens,
        TauxMedicaments, TauxConsommables, TauxChirurgies,
        TauxBilanSante, TauxAdmissions, TauxActes, 
        TauxObservations, TauxChambres
    },
    props: [],
    data() {
        return {
            liste_prestations: [
				{
                    libelle: 'Tous',
                    id: '0',
                },
                {
                    libelle: 'Consultations',
                    id: '1',
                },
                {
                    libelle: 'Analyses',
                    id: '2',
                },
				{
                    libelle: 'Examens',
                    id: '3',
                },
				{
                    libelle: 'Médicaments',
                    id: '4',
                },
				{
                    libelle: 'Consommables',
                    id: '5',
                },
                {
                    libelle: 'Chirurgies',
                    id: '6',
                },
				{
                    libelle: 'Bilan de santé',
                    id: '7',
                },
				{
					libelle: 'Actes',
                    id: '8',
				},
				{
					libelle: 'Chambres',
                    id: '9',
				},
				{
					libelle: 'Observations',
                    id: '10',
				},
				{
					libelle: 'Admissions',
                    id: '11',
				}
            ],
            filtre_prestation: '',
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        onFilterPrestation() {
			// let id_selected = this.filtre_prestation.id

			// if (id_selected > 0) {
			// 	for(let i = 1; i <= this.liste_prestations.length; i++) {
			// 		if (i != id_selected ) {
			// 			$('.prest-'+i).fadeOut(500)
			// 		}
			// 	}
			// 	setTimeout(() => {
			// 		$('.prest-'+id_selected ).fadeIn(500)
			// 	}, 500);
			// } else {
			// 	for(let i = 1; i <= this.liste_prestations.length; i++) {
			// 		$('.prest-'+i).fadeIn(500)
			// 	}
			// }
			
		},
    }
}